import jsCookie from 'js-cookie'

import AppConfig from '@src/config/AppConfig'

const cookieName = 'pbxxId'

function getPbxxId() {
  let cookieValue = jsCookie.get(cookieName)

  if (!cookieValue) {
    cookieValue = crypto.randomUUID()
  }

  jsCookie.set(cookieName, cookieValue, {
    expires: 365,
    domain: AppConfig.OMNIAUTH_COOKIE_DOMAIN,
  })

  return cookieValue
}

export default getPbxxId
